import type { JournalListItemDTO } from '~/shared/api/client/journals/journals.dto';

/* Номер и период через пробел; если заполнено одно поле — только оно */
export function getIssueMeta(
  issue: Pick<JournalListItemDTO, 'issue_number' | 'period'>,
): string {
  return [issue.issue_number?.trim(), issue.period?.trim()]
    .filter(Boolean)
    .join(' ');
}
